module.exports = __webpack_public_path__ + "img/bj.fe010cb5.svg";